// extracted by mini-css-extract-plugin
export default {"title":"AnimeCard_title__TMWo5","poster":"AnimeCard_poster__x42XO"};